import { toast } from '@codes/ui-kit/components/ui/use-toast';
import { CardView } from '@lemoncloud/lemon-payments-api';
import { Params } from '@lemoncloud/lemon-web-core';
import { useQuery } from '@tanstack/react-query';

import { bulkUpdateCards, cardQueryKeys, deleteCard, fetchCards } from '@codes/payments';
import { ListResult, useCustomMutation } from '@codes/shared';

import { BulkCardUpdateBody } from '../types';

export const useCards = (params: Params) =>
    useQuery<ListResult<CardView>>({
        queryKey: cardQueryKeys.list(params ?? {}),
        queryFn: async () => {
            const result = await fetchCards(params);
            return result;
        },
        refetchOnWindowFocus: false,
    });

export const useBulkUpdateCards = () => {
    return useCustomMutation((data: BulkCardUpdateBody) => bulkUpdateCards(data), {
        onError: error => {
            toast({ title: `${error.toString()}` });
        },
    });
};

export const useDeleteCard = () => {
    return useCustomMutation((id: string) => deleteCard(id), {
        onError: error => {
            toast({ title: `${error.toString()}` });
        },
    });
};
